import * as React from "react";
import { cn } from "@/lib/utils";

export interface WizardStepperProps {
  totalSteps: number;
  currentStep: number;
  className?: string;
}

export const WizardStepper = React.forwardRef<
  HTMLDivElement,
  WizardStepperProps
>(({ totalSteps, currentStep, className }, ref) => {
  return (
    <div
      ref={ref}
      className={cn("flex items-center justify-center space-x-2", className)}
    >
      {Array.from({ length: totalSteps }).map((_, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <div
                className={cn(
                  "h-[2px] w-4",
                  index <= currentStep
                    ? "bg-primary-foreground"
                    : "bg-secondary"
                )}
              />
            )}
            <div
              className={cn(
                "flex h-4 w-4 items-center justify-center rounded-full border",
                isCompleted
                  ? "border-primary-foreground bg-primary-foreground"
                  : isCurrent
                    ? "border-2 border-muted bg-muted/20"
                    : "border-secondary"
              )}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
});

WizardStepper.displayName = "WizardStepper";
